import React from "react";
import Provider from "./Provider.js";
export default function MultiplyProvider(props) {
    const { provider } = props;
    if (!provider.value1 || !provider.value2) {
        props.onProviderUpdate({
            ...provider,
            value1: { type: "constant", value: 1 },
            value2: { type: "constant", value: 1 },
        });
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { provider: provider.value1, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate({
                    ...provider,
                    value1: newP,
                }), formatNames: props.formatNames })),
        React.createElement("strong", null, " * "),
        React.createElement("div", { className: "sum-provider-item" },
            React.createElement(Provider, { formatNames: props.formatNames, hasHiddenType: props.hasHiddenType, provider: provider.value2, onProviderUpdate: (newP) => props.onProviderUpdate({
                    ...provider,
                    value2: newP,
                }) }))));
}
